import "./style.scss";
import CopyInput from "../CopyInput";

function OfferTicket({ data }) {
  return (
    <div className="offer-ticket">
      <div
        style={{
          backgroundColor: data?.bg,
        }}
        className="left-section"
      >
        <span className="font-title-normal">{data?.offer}</span>
      </div>
      <div
        style={{
          borderColor: data?.bg,
        }}
        className="right-section"
      >
        <span className="text-black font-title-xs fw-700 leading-4">
          {data?.title}
        </span>
        <CopyInput
          value={data?.code}
          className="offer-ticket-copy mt-1-5 mb-2"
          color={data?.text}
        />
        <p className="valid-date">Valid until {data?.valid}</p>
      </div>
    </div>
  );
}

export default OfferTicket;
